import { render, staticRenderFns } from "./ReportPmtaRelaysMailService.vue?vue&type=template&id=1487e89a&scoped=true"
import script from "./ReportPmtaRelaysMailService.vue?vue&type=script&lang=js"
export * from "./ReportPmtaRelaysMailService.vue?vue&type=script&lang=js"
import style0 from "./ReportPmtaRelaysMailService.vue?vue&type=style&index=0&id=1487e89a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1487e89a",
  null
  
)

export default component.exports